import React, { useState, useEffect } from 'react';
import moment from 'moment';

import UndoIcon from '@material-ui/icons/Undo';

import Modal from '../../shared/modal';
import Input from '../../shared/Input';
import DatePicker from '../../shared/date-picker/DatePicker';
import Button from '../../shared/Button';

const CaseShippingInfoModal = ({ open, onClose, onSubmit, onRevert, loading, initialValues }) => {
  const [date, setDate] = useState(moment());
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (initialValues && open) {
      setDate(initialValues?.collectionDate);
      setNotes(initialValues?.collectionNote || '');
    }
    if (!open) {
      setNotes('');
    }
  }, [open, initialValues]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Confirm Collection'
      fullWidth
    >
      <div className='close-order-modal__container'>
        <div className='p-b-md secondary font-bold'>
          Select a collection date & add any supporting notes
        </div>

        <div className='m-t-md'>
          <div className='field__title'>Collection Date</div>
          <DatePicker
            date={date}
            onDateChange={setDate}
          />
        </div>

        <div className='m-t-lg'>
          <div className='field__title'>Collection Note</div>
          <Input
            name='collectionNote'
            value={notes}
            type='textarea'
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '24px', width: '100%' }}>
        <Button type="cancel" text="Cancel" onClick={onClose} />
        <div className="d-flex">
          {!!initialValues?.collectionDate && (
            <div className="m-r-lg">
              <Button
                type="icon"
                onClick={onRevert}
              >
                <UndoIcon style={{ color: 'var(--app-text)' }} />
              </Button>
            </div>
          )}
          <Button
            text="Confirm"
            onClick={() => onSubmit(date, notes)}
            disabled={loading || !date}
            loading={loading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CaseShippingInfoModal;
